import clsx from 'clsx';
import { BRAND_NAME } from 'constants/Enums';
import styles from './styles.module.css';

function LoadingBM({ animateText = false }) {
  return (
    <div className={styles.wrapLoad}>
      <div className={styles['loading-3']}>
        <i />
        <i />
        <i />
        <i />
      </div>
      <p className={clsx(animateText && styles.animateTS)}>{BRAND_NAME}</p>
    </div>
  );
}

export default LoadingBM;
